<div [attr.test-id]="descriptor?.groupZoneID"
     class="box card-box"
     (click)="toggleCardEdit(true)"
     [attr.data-hidden]="!isCardVisible()"
     [class.card-has-errors]="group?.invalid"
     [class.card-group-has-errors]="isCardInvalid()"
     [class.dated]="descriptor?.isDated"
     [class.pointer]="!editMode"
     [class.disabled]="readOnly"
>
  <div class="box-header">
    <h3>{{ descriptor?.transId | translate }}</h3>
    <div class="card-dated-controls pull-right no-padding" *ngIf="!readOnly">
      <button type="button"
              class="btn white no-borders"
              tooltip="{{ 'TOOLTIPS.add_entry' | translate }}"
              placement="left"
              *ngIf="descriptor?.isDated && editMode"
              [disabled]="isGroupZoneLocked"
              (click)="addDatedCardEntity()">
        <i class="fa fa-light fa-plus" aria-hidden="true"></i>
      </button>
      <button type="button"
              class="btn white no-borders"
              tooltip="{{ 'TOOLTIPS.clone_entry' | translate }}"
              placement="left"
              *ngIf="descriptor?.isDated && editMode"
              [disabled]="isGroupZoneLocked"
              (click)="addDatedCardEntity(true)">
        <i class="far fa-clone" aria-hidden="true"></i>
      </button>
      <button type="button"
              class="btn white no-borders"
              [tooltip]="isGroupZoneLocked ? ('AI_GENERATION.generating' | translate) : ('AI_GENERATION.generate_with_ai' | translate)"
              placement="left"
              *ngIf="editMode && aiGeneratedZones.length > 0"
              [disabled]="isGroupZoneLocked"
              (click)="generateZoneValuesWithAI()">
        <i
          [ngClass]="isGroupZoneLocked ? 'fa fa-spinner fa-spin icon-primary' : 'fa-solid fa-wand-magic-sparkles icon-primary'"
          test-id="GenerateWithAiIcon" aria-hidden="true">
        </i>
      </button>
      <button type="button"
              class="btn white no-borders"
              tooltip="{{ 'TOOLTIPS.delete_entry' | translate }}"
              container="body"
              placement="left"
              *ngIf="shouldShowTrashIcon()"
              [disabled]="isGroupZoneLocked"
              (click)="deleteCardEntity()">
        <i class="fa fa-light fa-trash-alt" test-id="trashIcon" aria-hidden="true"></i>
      </button>
    </div>
  </div>

  <div class="box-body">
    <div class="text-center" *ngIf="groupedCards[groupedZoneName]">
      <div class="btn-group">
        <button *ngFor="let item of groupedCards[groupedZoneName] | keys"
                class="btn btn-sm btn-outline b-light"
                [ngClass]="{'b-danger text-danger': isFormInvalid(form?.controls[tabSheetID], item)}"
                (click)="activateGroup(item, $event)"
                [disabled]="isGroupZoneLocked"
                [attr.test-id]="'tabButton-' + item.split(':')[1]"
                [class.active]="groupedCards[groupedZoneName][item]">
          {{ item.split(':')[1] | translate }}
        </button>
      </div>
    </div>
    <ul class="error-list" *ngIf="group?.invalid && groupErrorText">
      <li *ngFor="let error of groupErrorMessages">
        {{ 'FORM_GENERATOR.ERRORS.' + error.text | translate: error.additionalValues }}
      </li>
    </ul>
    <ul class="error-list" *ngIf="group?.invalid && datesErrorText">
      <li *ngFor="let error of datesErrorMessages">
        {{ 'FORM_GENERATOR.ERRORS.' + error.text | translate }}
      </li>
    </ul>
    <div class="row body">
      <div class="card-container"
           [class.p-x-md]="descriptor?.isDated"
           [class.p-x-sm]="descriptor?.isDated">
        <div class="line" *ngIf="descriptor?.isDated">
          <i class="fa-regular fa-chevron-up arrow"
             [class.text-warning]="!group?.valid"></i>
        </div>
        <div class="text-primary dated-control dated-control-top card-end-date clearfix"
             *ngIf="descriptor?.isDated">
          <datepicker-input
            [ngClass]="dateFldsCls"
            [attr.test-id]="descriptor.groupZoneID + '-endDate'"
            *ngIf="editMode"
            [(ngModel)]="endDateValue"
            (ngModelChange)="updateDate($event,'enddate')"
            [formControl]="endDateControl"
            [minDate]="minDate"
            [maxDate]="maxDate"
            [hasEternity]="true"
            [groupZoneID]="descriptor.groupZoneID"
            [groupZoneDescriptor]="descriptor"
            [disabled]="isGroupZoneLocked">
          </datepicker-input>
          <div [attr.data-hidden]="editMode" style="padding-left: 11px;" [ngClass]="{'dates-disabled': readOnly}">
            {{ displayDate(endDateValue) }}
          </div>
        </div>
        <ng-template #fieldRowsContainer></ng-template>
        <div class="text-primary dated-control dated-control-bottom"
             *ngIf="descriptor?.isDated">
          <datepicker-input
            [ngClass]="dateFldsCls"
            [attr.test-id]="descriptor.groupZoneID + 'beginDate'"
            *ngIf="editMode"
            [(ngModel)]="beginDateValue"
            (ngModelChange)="updateDate($event, 'begindate')"
            [formControl]="beginDateControl"
            [minDate]="minDate"
            [maxDate]="maxDate"
            [hasEternity]="true"
            [groupZoneID]="descriptor.groupZoneID"
            [groupZoneDescriptor]="descriptor"
            [disabled]="isGroupZoneLocked">
          </datepicker-input>
          <div [attr.data-hidden]="editMode" style="padding-left: 11px;" [ngClass]="{'dates-disabled': readOnly}">
            {{ displayDate(beginDateValue) }}
          </div>
        </div>
        <div class="clearfix"></div>
        <div *ngIf="descriptor?.isDated"
             [ngClass]="{'scroll pointer': data.length > 1
             && !isGroupZoneLocked, 'disabled': isGroupZoneLocked
             }"
             (click)="onScrollClick($event)">
          <div [ngClass]="{'caret': data.length > 1}"
               [style.height]="(100 / data.length) + '%'"
               [style.top]="(activeEntity?.dataIndex * (100 / data.length)) + '%'"></div>
        </div>
      </div>
    </div>
    <div class="text-muted m-t-sm calculated-fields-disclaimer" *ngIf="hasCalculation()">
      <i class="fa-solid fa-circle-info"></i>
      {{ 'FORMS.calculated_fields_disclaimer' | translate }}
    </div>
    <div class="text-muted m-t-sm ai-disclaimer" *ngIf="showAiDisclaimer && editMode">
      <i class="fa-solid fa-circle-info"></i>
      {{ 'FORMS.ai_disclaimer' | translate }}
    </div>
  </div>
</div>

<gp-blocking-error-resolution-modal
  *ngIf="newBlockingErrors && newBlockingErrors.length"
  [blockingErrors]="newBlockingErrors"
  [zoneDescriptor]="lastFieldFocused?.descriptor"
  [groupZoneDescriptor]="descriptor"
  (onCancelChange)="cancelChange($event)"
  (onBackToEditMode)="backToEditMode($event)"
></gp-blocking-error-resolution-modal>
